<div
  [class.notification_active]="notificationService.isNotificationBarVisible"
  [class]="getNotificationStyleName()"
  class="block notification"
>
  <div class="notification__content-wrapper">
    <p class="notification__message">{{ notificationService.message }}</p>

    <button (click)="notificationService.closeNotificationBar()" class="notification__close-button">
      <img src="assets/img/icons/times.svg" alt="Close" />
    </button>
  </div>
</div>
